/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import { initializeFirebase } from "../../pushNotification";
import { isMobile } from "react-device-detect";


import { PushNotifications } from "@capacitor/push-notifications";
import { Toast } from "@capacitor/toast";
import { Browser } from "@capacitor/browser";
import { useAtom } from "jotai";
import {
    alertModal,
    appConstants,
    auth_token,
    bell,
    notify,
    permaStatus,
} from "../../atomstore/store";
import { getDeviceToken, setDeviceToken } from "../../atomstore/serviceAtoms";
import { useRequestProcessor } from "../../requestProcessor";
import { saveToken } from "../../queryfunctions/queryfunctions";
import { Capacitor } from "@capacitor/core";
import Constants from "../../constant";


const showToast = async (msg) => {
    await Toast.show({
        text: msg,
    });
};

//Broswer agents
let userAgentString = navigator.userAgent;

const isChrome =
    !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
const isFirefox = typeof InstallTrigger !== "undefined";
// Detect Safari
let safariAgent = userAgentString.indexOf("Safari") > -1;

const NotificationService = () => {
    const [constants] = useAtom(appConstants);
    const [, setNotification] = useAtom(notify);
    const [authToken] = useAtom(auth_token);
    const [, setModal] = useAtom(alertModal);
    const [, setShowBell] = useAtom(bell);
    const [permStatus, setPermStatus] = useAtom(permaStatus);
    const { useMutationWrapper } = useRequestProcessor();
    const saveTokenFn = useMutationWrapper("saveToken", (token) => {
        setPermStatus({ receive: "granted" });
        return saveToken(token);
    });
    const initializedRef = useRef(false);





    console.log("Permission Status", permStatus);
    const getDeliveredNotifications = async () => {
        const notificationList =
            await PushNotifications.getDeliveredNotifications();
        console.log("delivered notifications", notificationList);
    };

    const registerMobileNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();
        console.log("Check permissions: ", permStatus);

        if (permStatus.receive !== "granted") {
            permStatus = await PushNotifications.requestPermissions();
            if (permStatus.receive !== "granted") {
                setPermStatus({ receive: "denied" });
                showToast("Push Notification permission denied");
            } else {
                showToast("Push Notification permission granted");
                register();
            }
        } else {
            register();
        }
    };

    const register = async () => {
        console.log("Initializing HomePage");

        // Register with Apple / Google to receive push via APNS/FCM
        await PushNotifications.register();

        const handleNotificationUrlTap = async (notification) => {
            const url =
                notification?.notification?.data?.url ||
                notification?.notification?.data?.link ||
                notification?.data?.url ||
                null;

            if (!(typeof url === "string" && url.trim().length > 0)) return false;

            // Prefer AppLauncher (iOS + Android) so the OS can hand off to the native app
            // when the URL is an app/universal link or supported scheme. Fall back to
            // Capacitor Browser if AppLauncher isn't available or can't handle it.
            try {
                const appLauncher = Capacitor.Plugins?.AppLauncher;
                if (appLauncher?.openUrl) {
                    const res = await appLauncher.openUrl({ url });
                    if (res?.completed) return true;
                }
            } catch (e) {
                console.warn("[notification] AppLauncher.openUrl failed; fallback to Browser.open", e);
            }

            await Browser.open({ url });
            return true;
        };

        // On success, we should be able to receive notifications
        PushNotifications.addListener("registration", (token) => {
            console.log("token", token.value);
            setDeviceToken(token.value);
            saveTokenFn.mutate(token.value);
        });

        // Some issue with our setup and push will not work
        PushNotifications.addListener("registrationError", (error) => {
            alert("Error on registration: " + JSON.stringify(error));
        });

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener(
            "pushNotificationReceived",
            (notification) => {
                // setnotifications(notifications => [...notifications, { id: notification.id, title: notification.title, body: notification.body, type: 'foreground' }])
                console.log("pushNotificationReceived", notification);
                setShowBell(true);
                setNotification({
                    title: notification.title,
                    subtitle: notification.body,
                });
                // this.props.setNotification(notification.title, notification.body);
                // this.props.fetchChat(0);
            }
        );

        // Method called when tapping on a notification
        PushNotifications.addListener(
            "pushNotificationActionPerformed",
            async (notification) => {
                const opened = await handleNotificationUrlTap(notification);
                if (!opened) window.location = "/notifications";
            }
        );

        // If the app was cold-started by tapping a notification, handle it once here.
        try {
            const launchNotification = await PushNotifications.getLaunchNotification?.();
            if (launchNotification) {
                const opened = await handleNotificationUrlTap(launchNotification);
                if (!opened) window.location = "/notifications";
            }
        } catch (e) {
            console.warn("[notification] getLaunchNotification failed", e);
        }
    };

    const initNotificationFlow = () => {
        if (Capacitor.isNativePlatform() && (Constants.env.platform === "android" || Constants.env.platform === "ios")) {
            registerMobileNotifications();
        } else if (!("Notification" in window)) {
            // Check if the browser supports notifications
            setPermStatus({ receive: "default" });
            alert("This browser does not support desktop notification");
        } else if (Notification.permission !== "granted") {
            setPermStatus({ receive: "denied" });
            setModal({
                state: true,
                type: "Success",
                isConfirm: false,
                message: constants?.pushPermissionMessage,
                onOkPressed: () => {
                    initializeFirebase(
                        (token) => {
                            let deviceToken = getDeviceToken();
                            if (!deviceToken && deviceToken !== token) {
                                setDeviceToken(token);
                                saveTokenFn.mutate(token);
                            }
                        },
                        (notification) => {
                            setShowBell(true);
                            setNotification({
                                title: notification.title,
                                subtitle: notification.body,
                            });
                            //   this.props.fetchChat(0);
                        },
                        (message) =>
                            setModal({
                                state: true,
                                type: "Error",
                                isConfirm: false,
                                message: message,
                                onOkPressed: () => { },
                            })
                    );
                },
                onCancelPressed: () => { },
            });
        } else if (Notification.permission === "granted") {
            initializeFirebase(
                (token) => {
                    let deviceToken = localStorage.getItem("deviceFCMToken"); //getDeviceToken();
                    if (!deviceToken || deviceToken !== token) {
                        setDeviceToken(token);
                        saveTokenFn.mutate(token);
                    }
                },
                (notification) => {
                    setShowBell(true);
                    setNotification({
                        title: notification.title,
                        subtitle: notification.body,
                    });
                    //   this.props.fetchChat(0);
                },
                (message) =>
                    setModal({
                        state: true,
                        type: "Error",
                        isConfirm: false,
                        message: message,
                        onOkPressed: () => { },
                    })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    useEffect(() => {
        // 🚫 User not logged in - reset ref so it can initialize on next login
        if (!authToken || authToken === '""') {
            initializedRef.current = false;
            return;
        }

        // 🚫 Already initialized (route change / rerender / StrictMode)
        if (initializedRef.current) return;

        initializedRef.current = true;

        // ✅ RUN YOUR EXISTING NOTIFICATION LOGIC HERE
        initNotificationFlow();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken]);

    return <div></div>;
};

export default NotificationService;
